import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Typography, Breadcrumb, Space, Card, Table, Grid } from 'antd';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Registration2026() {
  const { xs } = useBreakpoint();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dataSource = [
    { key: 'external', category: 'External Participants', fee: 'Rp150.000' },
    { key: 'students', category: 'Binawan Students', fee: 'Rp50.000' },
    { key: 'lecturers', category: 'Binawan Lecturers', fee: 'Rp100.000' },
    { key: 'oral', category: 'Oral Presentation', fee: 'Rp550.000' },
  ];

  const columns = [
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Fee',
      dataIndex: 'fee',
      key: 'fee',
      align: 'right',
    },
  ];

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Registration</Breadcrumb.Item>
          </Breadcrumb>
        </Col>

        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32} style={{ width: '100%' }}>
            <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>
              Registration Fees
            </Text>

            <Card style={{ width: '100%', borderRadius: 12, boxShadow: '0 2px 8px 1px #f1f3f4' }}>
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                size={xs ? 'small' : 'middle'}
              />
            </Card>

            <Space direction="vertical" size={8} style={{ width: '100%' }}>
              <Text style={{ fontSize: 16, fontWeight: 600 }}>Note</Text>
              <Text style={{ fontSize: 15 }}>
                The fees above are per participant category. For registration and payment instructions, please follow the information provided by the committee.
              </Text>
            </Space>
          </Space>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default Registration2026;
